// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_4xp","cls2":"LoswpExitIntentModal-cls2_Wra LoswpExitIntentModal-cls1_4xp"};